import React from 'react'
import PropTypes from 'prop-types'
import { Box, Heading, Text } from '@chakra-ui/react'
import UnderLine from '../UnderLine/UnderLine'

const spacing = '9px'
function UnderlineHeading({
  text,
  subtext,
  variant,
  subVariant,
  children,
  ...rest
}) {
  return (
    <Box>
      <Heading variant={variant} {...rest}>
        {text || children}
      </Heading>
      {subtext && (
        <Box mt={spacing}>
          <Text variant={subVariant} textOverflow={null}>
            {subtext}
          </Text>
        </Box>
      )}
      <Box mt={spacing}>
        <UnderLine />
      </Box>
    </Box>
  )
}

UnderlineHeading.propTypes = {
  children: PropTypes.node,
  subVariant: PropTypes.string,
  subtext: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.string,
}

export default UnderlineHeading
